/**
 * Generated from GameScreenLayout.fla
 */
export function GameScreenLayout(this: IGameScreenLayout) {
	const main = this.main;
	GameScreenLayout_main.call(this.main);
	main.x = 1024;
	main.y = 768;
	if (main.onLayout) main.onLayout();
	return this;
}
export function GameScreenLayout_main(this: IGameScreenLayout_main) {
	const postcardEnd = this.postcardEnd;
	GameScreenLayout_postcardEnd.call(this.postcardEnd);
	postcardEnd.x = 6.75;
	postcardEnd.y = -149.15;
	if (postcardEnd.scale) postcardEnd.scale.x = 0.900;
	if (postcardEnd.scale) postcardEnd.scale.y = 0.900;
	if (postcardEnd.onLayout) postcardEnd.onLayout();
	const luna = this.luna;
	GameScreenLayout_luna.call(this.luna);
	luna.x = 684.95;
	luna.y = 850.15;
	luna.width = 567.39;
	luna.height = 581.44;
	if (luna.onLayout) luna.onLayout();
	const buttonComplete = this.buttonComplete;
	GameScreenLayout_buttonComplete.call(this.buttonComplete);
	buttonComplete.x = 0.75;
	buttonComplete.y = 599.2;
	buttonComplete.width = 296.00;
	buttonComplete.height = 305.00;
	if (buttonComplete.onLayout) buttonComplete.onLayout();
	const buttonSave = this.buttonSave;
	GameScreenLayout_buttonSave.call(this.buttonSave);
	buttonSave.x = -879.25;
	buttonSave.y = 615.85;
	buttonSave.width = 255.00;
	buttonSave.height = 256.00;
	if (buttonSave.onLayout) buttonSave.onLayout();
	const buttonPrint = this.buttonPrint;
	GameScreenLayout_buttonPrint.call(this.buttonPrint);
	buttonPrint.x = -618.2;
	buttonPrint.y = 615.85;
	buttonPrint.width = 255.00;
	buttonPrint.height = 256.00;
	if (buttonPrint.onLayout) buttonPrint.onLayout();
	return this;
}
function GameScreenLayout_postcardEnd(this: IGameScreenLayout_postcardEnd) {
	const background = this.background;
	GameScreenLayout_background.call(this.background);
	background.x = 0;
	background.y = 0;
	background.width = 1790.00;
	background.height = 1325.00;
	if (background.onLayout) background.onLayout();
	return this;
}
function GameScreenLayout_background(this: IGameScreenLayout_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("postcard-rio-1.png", 0.500, 0.500);
	return this;
}
function GameScreenLayout_luna(this: IGameScreenLayout_luna) {
	if (this.setLayoutTexture) this.setLayoutTexture("luna.png", 0.420, 1.000);
	return this;
}
function GameScreenLayout_buttonComplete(this: IGameScreenLayout_buttonComplete) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-home-green.png", 0.500, 0.502);
	return this;
}
function GameScreenLayout_buttonSave(this: IGameScreenLayout_buttonSave) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-save.png", 0.500, 0.500);
	return this;
}
function GameScreenLayout_buttonPrint(this: IGameScreenLayout_buttonPrint) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-print.png", 0.500, 0.500);
	return this;
}
interface IGameScreenLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IGameScreenLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IGameScreenLayoutSprite extends IGameScreenLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IGameScreenLayoutText extends IGameScreenLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IGameScreenLayoutPolygon extends Array<number> {
}
interface IGameScreenLayout {
	readonly main: IGameScreenLayout_main;
}
interface IGameScreenLayout_main extends IGameScreenLayoutContainer {
	readonly postcardEnd: IGameScreenLayout_postcardEnd;
	readonly luna: IGameScreenLayout_luna;
	readonly buttonComplete: IGameScreenLayout_buttonComplete;
	readonly buttonSave: IGameScreenLayout_buttonSave;
	readonly buttonPrint: IGameScreenLayout_buttonPrint;
}
interface IGameScreenLayout_postcardEnd extends IGameScreenLayoutContainer {
	readonly background: IGameScreenLayout_background;
}
interface IGameScreenLayout_background extends IGameScreenLayoutSprite {
}
interface IGameScreenLayout_luna extends IGameScreenLayoutSprite {
}
interface IGameScreenLayout_buttonComplete extends IGameScreenLayoutSprite {
}
interface IGameScreenLayout_buttonSave extends IGameScreenLayoutSprite {
}
interface IGameScreenLayout_buttonPrint extends IGameScreenLayoutSprite {
}
